import { render, staticRenderFns } from "./AccionVerAnotacionesSii.vue?vue&type=template&id=f6058878&scoped=true&"
import script from "./AccionVerAnotacionesSii.vue?vue&type=script&lang=js&"
export * from "./AccionVerAnotacionesSii.vue?vue&type=script&lang=js&"
import style0 from "./AccionVerAnotacionesSii.vue?vue&type=style&index=0&id=f6058878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6058878",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6058878')) {
      api.createRecord('f6058878', component.options)
    } else {
      api.reload('f6058878', component.options)
    }
    module.hot.accept("./AccionVerAnotacionesSii.vue?vue&type=template&id=f6058878&scoped=true&", function () {
      api.rerender('f6058878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/AccionVerAnotacionesSii.vue"
export default component.exports